import { createContext, ReactNode, useContext } from 'react'

interface ContextState {
  isCustomer: boolean
  isSupplier: boolean
}

interface ContactTypeContextProviderProps {
  children?: ReactNode
}

const ContactTypeContext = createContext<ContextState | undefined>(undefined)

export const ContactTypeContextProvider = ({
  children,
  isCustomer,
  isSupplier,
}: ContactTypeContextProviderProps & ContextState) => {
  return <ContactTypeContext.Provider value={{ isCustomer, isSupplier }}>{children}</ContactTypeContext.Provider>
}

export const useContactType = () => {
  const context = useContext(ContactTypeContext)

  if (!context) {
    throw new Error('useContactType must be used within ContactTypeContextProvider')
  }

  return context
}
